import mapObj from "map-obj"

export const boolToYesNo = (value?: boolean | null) => (value ? "yes" : value === false ? "no" : "")

export const capitalize = (value: string) => value.charAt(0)?.toUpperCase() + value.slice(1)

export const segmentInThree = (value: string | null) =>
  value ? value.replace(/(.{3})/g, "$1 ").trim() : ""

export const pickInitialValues = <T extends Record<string, any[]>>(values: {
  [K in keyof T]: T[K]
}) =>
  mapObj(values, (key, value) => [
    key.toString(),
    process.env.NEXT_PUBLIC_DEBUG_DATA === "true" && value[1] !== undefined ? value[1] : value[0],
  ]) as { [K in keyof T]: T[K][0] }

export const notEmpty = <T extends string>(value?: T | null): value is T =>
  value !== undefined && value !== null && value.trim() !== ""
